import "./style/index.scss";
import dayjs from "dayjs";
import * as Icon from "@ant-design/icons";
import { Row, Form, Col, Select, Image, Switch, Tag, Flex, Skeleton, Empty, Button, Typography } from "antd";
import { useEffect, useState } from "react";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import { buscarComparativoResultadoEmpresa } from "../../services/comparativoResultadoService";
import { ComparativoResultadoModel } from "../../models/comparativoResultado/comparativoResultadoModel";
import { buscarEmpresa } from "../../services/empresaService";
import { listarSorteio } from "../../services/sorteioService";
import { ColumnsType } from "antd/es/table";
import { DetalhesSorteioModel } from "../../models/sorteio/detalhesSorteioModel";
import { EmpresaModel } from "../../models/empresa/empresaModel";
import TableComponent from "../../components/table/tableComponent";
import { removeFilhos } from "../../util/functions/removeFilhos";
import { resetListComparativoResultado } from "../../redux/slices/comparativoResultado/comparativoResultadoSlice";

dayjs.locale("pt-br");

const tableTitle = [
  { index: 1, title: "PONTO DE EQUILÍBRIO" },
  { index: 2, title: "RESULTADO PARCIAL" },
  { index: 3, title: "RESULTADO FINAL" },
];

const ComparativoEmpresa = () => {
  //estados globais
  const comparativoResultadoState = useAppSelector((state) => state.comparativoResultado);
  const empresaState = useAppSelector((state) => state.empresa);
  const sorteioState = useAppSelector((state) => state.sorteio);
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const [percentuais, setPorcentagem] = useState(false);

  let watchIdSorteio = Form.useWatch("idSorteio", form);

  useEffect(() => {
    dispatch(setTitle("RESUMO DO RESULTADO - ENTRE FASES"));
    dispatch(buscarEmpresa(empresaState.busca));

    if (persistedState.user.empresa !== null) {
      form.setFieldsValue({
        idEmpresa: persistedState.user.empresa.idEmpresa,
      });
      onChangeEmpresa(persistedState.user.empresa.idEmpresa);
    }
  }, []);

  const handleChangePercentuais = (checked: any) => {
    setPorcentagem(checked);
  };

  const onChangeEmpresa = (value: number) => {
    form.resetFields(["idSorteio"]);

    resetListComparativoResultado();

    dispatch(listarSorteio(value.toString()));
  };

  const submit = () => {
    dispatch(buscarComparativoResultadoEmpresa(watchIdSorteio));
  };

  const columns: ColumnsType<ComparativoResultadoModel> = [
    {
      title: "",
      dataIndex: "denominacao",
      key: "0",
      width: 250,
      render: (_, record) => (
        <Typography.Text style={{ width: 180, fontSize: "12px" }} ellipsis={{ tooltip: record.denominacao }}>
          {record.denominacao}
        </Typography.Text>
      ),
    },
    {
      title: "VALOR",
      key: "1",
      dataIndex: ["valorE", "percentualE"],
      align: "center",
      render: (_, record) => {
        return (
          <>
            {percentuais ? (
              <>
                {record.percentualE ? (
                  <div className={Math.sign(parseInt(record.valorE)) === -1 ? "valorRowResultado valorNegativo" : "valorRowResultado"}>
                    <div>{record.valorE}</div>
                    <Tag>{record.percentualE}</Tag>
                  </div>
                ) : (
                  <div className={Math.sign(parseInt(record.valorE)) === -1 ? "valorRowResultado valorNegativo" : "valorRowResultado"}>
                    <div>{record.valorE}</div>
                    <div className="tagVazia"></div>
                  </div>
                )}
              </>
            ) : (
              <div className={Math.sign(parseInt(record.valorE)) === -1 ? "valorNegativo" : ""}>{record.valorE}</div>
            )}
          </>
        );
      },
    },
    {
      title: "VALOR",
      key: "2",
      dataIndex: ["valorP", "percentualP"],
      align: "center",
      render: (_, record) => {
        return (
          <>
            {percentuais ? (
              <>
                {record.percentualP ? (
                  <div className={Math.sign(parseInt(record.valorP)) === -1 ? "valorRowResultado valorNegativo" : "valorRowResultado"}>
                    <div>{record.valorP}</div>
                    <Tag>{record.percentualP}</Tag>
                  </div>
                ) : (
                  <div className={Math.sign(parseInt(record.valorP)) === -1 ? "valorRowResultado valorNegativo" : "valorRowResultado"}>
                    <div>{record.valorP}</div>
                    <div className="tagVazia"></div>
                  </div>
                )}
              </>
            ) : (
              <div className={Math.sign(parseInt(record.valorP)) === -1 ? "valorNegativo" : ""}>{record.valorP}</div>
            )}
          </>
        );
      },
    },
    {
      title: "VALOR",
      key: "3",
      dataIndex: ["valorR", "percentualR"],
      align: "center",
      render: (_, record) => {
        return (
          <>
            {percentuais ? (
              <>
                {record.percentualR ? (
                  <div className={Math.sign(parseInt(record.valorR)) === -1 ? "valorRowResultado valorNegativo" : "valorRowResultado"}>
                    <div>{record.valorR}</div>
                    <Tag>{record.percentualR}</Tag>
                  </div>
                ) : (
                  <div className={Math.sign(parseInt(record.valorR)) === -1 ? "valorRowResultado valorNegativo" : "valorRowResultado"}>
                    <div>{record.valorR}</div>
                    <div className="tagVazia"></div>
                  </div>
                )}
              </>
            ) : (
              <div className={Math.sign(parseInt(record.valorR)) === -1 ? "valorNegativo" : ""}>{record.valorR}</div>
            )}
          </>
        );
      },
    },
  ];

  const displayedColumnsFinal = columns.map((column, index) => {
    if (index > 0) {
      const title = tableTitle.find((a: any) => a.index === index);
      column.title = <div className="tableTitle">{title?.title}</div>;
      return column;
    }
  });

  const determineRowClassName = (record: any) => {
    if (record.codigo === "RM_01") {
      return "row-cinza";
    } else if (record.codigo === "RM_03" || record.codigo === "RM_05") {
      return "row-light-yellow ";
    } else if (record.codigo === "RM_08") {
      return "row-yellow";
    }
    return ""; // Retorna uma string vazia se nenhuma classe especial for necessária
  };

  return (
    <Flex vertical>
      <Form layout="vertical" form={form} onFinish={submit}>
        <Row gutter={12} align="bottom">
          <Col span={14}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item
                  label="Empresa"
                  name="idEmpresa"
                  rules={[
                    {
                      required: true,
                      message: "Campo obrigatório",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="labelSearch"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: 300 }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item
                label="Data do sorteio"
                name="idSorteio"
                rules={[
                  {
                    required: true,
                    message: "Campo obrigatório",
                  },
                ]}
              >
                <Select
                  showSearch
                  style={{ width: 140 }}
                  loading={sorteioState.loadingEmpresas}
                  options={sorteioState.listSorteioEmpresas.map((a: DetalhesSorteioModel) => ({
                    value: a.idSorteio,
                    label: dayjs(a.dataSorteio).format("DD/MM/YYYY"),
                  }))}
                />
              </Form.Item>
              <Form.Item label=" " name="button">
                <Button className="addButton buttonPrimary" htmlType="submit" icon={<Icon.MergeCellsOutlined />}>
                  COMPARAR
                </Button>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
      {watchIdSorteio !== undefined && comparativoResultadoState.listEmpresa.length !== 0 && (
        <Row gutter={12} style={{ marginBottom: "1%" }}>
          <Col className="cadastrarCol" span={8} offset={16}>
            <Col>
              Visualizar % <Switch size="small" defaultChecked={percentuais} onChange={handleChangePercentuais} />
            </Col>
          </Col>
        </Row>
      )}
      {comparativoResultadoState.loadingEmpresa ? (
        <Flex
          style={{
            width: "100%",
            height: "400px",
            alignItems: "center",
          }}
          gap={12}
        >
          <Skeleton.Button style={{ height: "300px", width: 250, marginTop: "100px" }} shape="square" active />
          <Skeleton.Button style={{ height: "400px" }} shape="square" block active />
          <Skeleton.Button style={{ height: "400px" }} shape="square" block active />
          <Skeleton.Button style={{ height: "400px" }} shape="square" block active />
        </Flex>
      ) : (
        <div className="comparativoResultado">
          {watchIdSorteio !== undefined && comparativoResultadoState.listEmpresa.length !== 0 ? (
            <TableComponent
              loading={comparativoResultadoState.loadingEmpresa}
              data={removeFilhos(comparativoResultadoState.listEmpresa)}
              rowKey="ordem"
              columns={columns}
              expandable={{
                childrenColumnName: "filhos",
                defaultExpandAllRows: false,
              }}
              pagination={false}
              rowClassName={determineRowClassName}
              tableProps={{ className: "bordered-table-resultado" }}
            />
          ) : (
            <Empty
              description={
                watchIdSorteio === undefined && comparativoResultadoState.listEmpresa.length !== 0 ? <span>Não existem dados para comparar</span> : <span>Clique em comparar para obter os dados</span>
              }
            />
          )}
        </div>
      )}
    </Flex>
  );
};

export default ComparativoEmpresa;
